import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Star } from 'lucide-react';
import { toast } from 'sonner';

/**
 * CinemaRatingsPanel — admin card (VideoToliModerationPanel deprecated in v50.14).
 */
export function VideoToliModerationPanel() { return null; /* deprecated */ }

export function CinemaRatingsPanel() {
  const [agg, setAgg] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try { const r = await axios.get('/api/admin-ext/cinema-ratings'); setAgg(r.data?.aggregated || []); }
      finally { setLoading(false); }
    })();
  }, []);
  return (
    <div className="mb-4 p-4 rounded-2xl bg-gradient-to-br from-yellow-500/10 to-orange-500/10 border border-yellow-500/30" data-testid="cinema-ratings-admin">
      <div className="flex items-center gap-2 mb-3">
        <Star className="w-4 h-4 text-yellow-300" />
        <h4 className="font-bold text-yellow-200 text-sm">Notes utilisateurs — sorties & box office</h4>
      </div>
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : agg.length === 0 ? (
        <div className="text-[11px] text-yellow-200/50">Aucune note pour le moment.</div>
      ) : (
        <div className="space-y-1 max-h-64 overflow-y-auto">
          {agg.map(r => (
            <div key={r.target_id} className="p-2 rounded-lg bg-black/30 border border-yellow-500/20 flex items-center gap-2">
              <div className="flex-1 min-w-0">
                <div className="text-xs font-semibold text-white truncate">{r.target_title || r.target_id}</div>
                <div className="text-[10px] text-yellow-200/60">{r.target_kind === 'box_office' ? 'Box office' : 'Sortie'} · {r.count} note(s)</div>
              </div>
              <div className="text-sm font-bold text-yellow-300 flex items-center gap-0.5">
                <Star className="w-3.5 h-3.5 fill-yellow-300" /> {r.avg.toFixed(1)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
